import styled from 'styled-components';

export const AdaText = styled.span`
  display: none;
`;
